(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cm-review-summary"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.cmReviewClockInstalled) return;
  window.cmReviewClockInstalled = true;
  var storageKey = 'cm-cart-session-end-v1';
  var end = 0;
  try { end = Number(sessionStorage.getItem(storageKey)) || 0; } catch (error) {}
  function tick() {
    var clocks = document.querySelectorAll('[data-cm-session-clock]');
    var active = Array.from(clocks).some(function (clock) {
      var drawer = clock.closest('[data-cart-drawer]');
      return !drawer || (!drawer.hidden && drawer.classList.contains('is-open'));
    });
    if (!end && active) {
      var minutes = Math.max(1, Math.min(30, Number(clocks[0].getAttribute('data-minutes')) || 10));
      end = Date.now() + minutes * 60000;
      try { sessionStorage.setItem(storageKey, String(end)); } catch (error) {}
    }
    if (!end) return;
    var seconds = Math.max(0, Math.ceil((end - Date.now()) / 1000));
    var value = String(Math.floor(seconds / 60)).padStart(2, '0') + ':' + String(seconds % 60).padStart(2, '0');
    clocks.forEach(function (clock) {
      var output = clock.querySelector('[data-cm-session-left]');
      if (output) output.textContent = seconds > 0 ? value : clock.getAttribute('data-expired');
    });
  }
  tick();
  setInterval(tick, 1000);
})();
  } catch(e) { console.error(e); }
})();

})();
